import React, { useState, useEffect, useRef, type PropsWithChildren } from 'react';

import { NudgeSpotlight } from '@atlassiansox/nudge-tooltip';
import { layers } from '@atlaskit/theme/constants';
import { useLocalStorage } from '@atlassian/jira-insights-common';
import { useNextBestTaskPanel } from '@atlassian/jira-insights-next-best-task';
import { useIntl } from '@atlassian/jira-intl';
import { useAccountId } from '@atlassian/jira-tenant-context-controller';
import { NEXT_BEST_TASK_NAMESPACE } from './constants';
import messages from './messages';

function useOnceFalse(inputValue: boolean) {
	const previousInputValue = useRef(inputValue);
	const [hasChangedToFalse, setHasChangedToFalse] = useState(false);

	useEffect(() => {
		if (previousInputValue.current && inputValue === false) {
			setHasChangedToFalse(true);
		}

		previousInputValue.current = inputValue;
	}, [inputValue, setHasChangedToFalse]);

	return hasChangedToFalse;
}

export const NextBestTaskSpotlight = ({ children }: PropsWithChildren) => {
	const { formatMessage } = useIntl();
	const { isOpen } = useNextBestTaskPanel();
	const accountId = useAccountId();

	const [hasSpotlightBeenViewed, setHasSpotlightBeenViewed] = useLocalStorage<boolean>(
		NEXT_BEST_TASK_NAMESPACE,
		`spotlight-${accountId}`,
		{
			defaultValue: false,
		},
	);

	const hasPanelBeenHidden = useOnceFalse(isOpen || false);

	const isSpotlightVisible = hasPanelBeenHidden && !hasSpotlightBeenViewed;

	return (
		<NudgeSpotlight
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
			pulseBorderRadius={'0 20px 20px 0' as any}
			position="bottom-start"
			content={formatMessage(messages.spotlightMessage)}
			hidden={!isSpotlightVisible}
			setHidden={() => {
				/* handled via alternate state */
			}}
			onOutsideClick={() => setHasSpotlightBeenViewed(true)}
			zIndex={layers.dialog()}
		>
			{children}
		</NudgeSpotlight>
	);
};
